<template>
  <div>
    <!-- MODAL CHOOSE IMAGE -->
    <sweet-modal ref="modalChooseImage" width="50vw" :title="$t('ct-element-images')">
      <div class="modal-choose-image">
        <draggable class="modal-choose-image-container" handle=".action-move-img" v-model="internal_config.allImages">
          <div
            class="modal-choose-box"
            v-for="(image, index) in internal_config.allImages"
            :key="index"
          >
            <div :style="{ backgroundImage: `url('${image}')` }" class="modal-choose-box-image"/>
            <div class="modal-choose-image-options">
              <span class="action-move-img"><font-awesome-icon :icon="['fas', 'arrows-alt']" color="#fff"/></span>
              <span v-if="internal_config.allImages.length > 2" @click.prevent="deleteImage(index)">
              <font-awesome-icon :icon="['far', 'trash-alt']" color="#fff"/>
            </span>
            </div>
          </div>
        </draggable>
      </div>
      <button
        slot="button"
        class="btn btn-primary float-left ml-0"
        @click="getImages"
      ><i class="svg-icon svgi-add-page"></i>{{ $t('ct-element-images')}}
      </button>
      <button
        slot="button"
        class="btn btn-outline-light"
        @click="cancel"
      >{{ $t('ct-cancel') }}
      </button>
      <button
        slot="button"
        class="btn btn-success"
        @click="save"
      ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
      </button>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import Draggable from 'vuedraggable';

export default {
  name: 'ImageGalleryConfigModals',
  components: {
    SweetModal,
    Draggable
  },
  data() {
    return {
      internal_config: false,
      internal_config_current: false,
      callback: false
    };
  },
  methods: {
    init(config, callback = false) {
      this.internal_config = config;
      this.callback = callback;

      this.internal_config_current = {...this.internal_config};
    },
    cancel() {
      this.callback(this.internal_config_current);
      this.$refs.modalChooseImage.close();
    },
    open(modal) {
      if (this.$refs[modal]) { this.$refs[modal].open() }
    },
    deleteImage(index) {
      this.internal_config.allImages.splice(index, 1);
      this.internal_config.images.splice(index, 1);
    },
    save() {
      if (this.callback && typeof this.callback === 'function') {
        // this.internal_config.allImages = {...this.internal_config.images}
        this.callback(this.internal_config);
        this.$refs['modalChooseImage'].close();
      }
    },
    getImages() {
      document.getElementsByClassName(
        'panel-components-right'
      )[0].style.zIndex = 0;

      let values = {
        action: 'open',
        type: 'Images',
        save: this.saveFile,
        close: this.closeFile,
        maxSelectedFiles: 10
      };
      this.$root.$emit('fileMananger', values);
    },
    async saveFile(images) {
      this.$loading.show();

      document
        .getElementsByClassName('panel-components-right')[0]
        .removeAttribute('style');

      this.internal_config.allImages.push(images);

      let values = {
        action: 'close',
        type: 'Files',
        save: this.saveFile,
        close: this.closeFile
      };
      this.$root.$emit('fileMananger', values);

      this.$loading.hide();
    },
    closeFile() {
      document
        .getElementsByClassName('panel-components-right')[0]
        .removeAttribute('style');

      let values = {
        action: 'close',
        type: 'Files',
        save: this.saveFile,
        close: this.closeFile
      };
      this.$root.$emit('fileMananger', values);
    }

  }
};
</script>
<style lang="scss" scoped>

  /**  MODAL CHOOSE IMAGE */

  .modal-choose-image {
    display: flex;
    flex-direction: column;

    :nth-child(4) {
      text-align: right;
    }
  }

  .modal-choose-image-container {
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    margin: 20px 0 20px 0;
  }

  .modal-choose-box {
    position: relative;
    background-color: rgba(29, 64, 89, 0.8);
    border-radius: 10px;

    .modal-choose-box-image {
      width: 100%;
      height: 150px;
      border-radius: 10px;
      opacity: 1;
      display: block;
      transition: 0.5s ease;
      backface-visibility: hidden;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    &:hover .modal-choose-box-image {
      opacity: 0.3;
    }

    .modal-choose-image-options {
      transition: 0.5s ease;
      opacity: 0;
      position: absolute;
      width: 100px;
      height: 34px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      text-align: center;

      span {
        width: 34px;
        height: 34px;
        border-radius: 100%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
          background-color: gray;
        }
      }
    }

    &:hover .modal-choose-image-options {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/ImageGallery/ConfigModals.vue